module.exports = __webpack_public_path__ + "img/try-one.12c483ad.png";